// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as HomeRouteImport } from './routes/home'
import { Route as JoinRouteImport } from './routes/join'
import { Route as LandingRouteImport } from './routes/landing'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as AdminReportsRouteImport } from './routes/admin.reports'
import { Route as PairTokenRouteImport } from './routes/pair.$token'
import { Route as RoomCodeRouteImport } from './routes/room.$code'
import { Route as DotlovableOauthConsentRouteImport } from './routes/[.]lovable.oauth.consent'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const DemoRoute = DemoRouteImport.update({
            id: '/demo',path: '/demo',getParentRoute: () => rootRouteImport
          })
const HomeRoute = HomeRouteImport.update({
            id: '/home',path: '/home',getParentRoute: () => rootRouteImport
          })
const JoinRoute = JoinRouteImport.update({
            id: '/join',path: '/join',getParentRoute: () => rootRouteImport
          })
const LandingRoute = LandingRouteImport.update({
            id: '/landing',path: '/landing',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const ProfileRoute = ProfileRouteImport.update({
            id: '/profile',path: '/profile',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const AdminReportsRoute = AdminReportsRouteImport.update({
            id: '/admin/reports',path: '/admin/reports',getParentRoute: () => rootRouteImport
          })
const PairTokenRoute = PairTokenRouteImport.update({
            id: '/pair/$token',path: '/pair/$token',getParentRoute: () => rootRouteImport
          })
const RoomCodeRoute = RoomCodeRouteImport.update({
            id: '/room/$code',path: '/room/$code',getParentRoute: () => rootRouteImport
          })
const DotlovableOauthConsentRoute = DotlovableOauthConsentRouteImport.update({
            id: '/.lovable/oauth/consent',path: '/.lovable/oauth/consent',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthRoute: AuthRoute,DemoRoute: DemoRoute,HomeRoute: HomeRoute,JoinRoute: JoinRoute,LandingRoute: LandingRoute,PrivacyRoute: PrivacyRoute,ProfileRoute: ProfileRoute,TermsRoute: TermsRoute,AdminReportsRoute: AdminReportsRoute,PairTokenRoute: PairTokenRoute,RoomCodeRoute: RoomCodeRoute,DotlovableOauthConsentRoute: DotlovableOauthConsentRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)